export default class AuthService {
  constructor (Api) {
    this.api = Api;
  }

  getAuth () {
    return this.api.post('login');
  }
}
